import React from "react";
import { Link } from "react-router-dom";
import { Icon, fmtNum, gradientOf } from "./ui";
import { avatarUri } from "../assets/avatars";

/** แทน {{user}} ด้วยชื่อผู้ใช้ */
export const personalize = (text, name = "คุณ") => String(text || "").replaceAll("{{user}}", name);

export default function CharacterCard({ c, userName }) {
  return (
    <Link to={`/c/${c.id}`} className="char-card" aria-label={c.name}>
      <div className="char-card__img" style={{ background: c.image ? `center / cover url(${c.image})` : gradientOf(c.colors, c.id || c.name) }}>
        {c.image ? null : <img className="char-card__gen" src={avatarUri(c.id || c.name)} alt="" />}
        <span className="char-card__stat"><Icon name="chat" size={12} /> {fmtNum(c.messageCount)}</span>
      </div>
      <div>
        <div className="char-card__name clamp-1">{c.name}</div>
        <div className="char-card__tag clamp-2">{personalize(c.tagline, userName)}</div>
      </div>
    </Link>
  );
}
